<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>法务-律师事务所 使用说明:<br>
          <span>1、单独记录律师事务所信息,供查询使用!</span><br>
          <span>2、查询关键字:名称，负责人，状态。</span><br>
        </h5>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
     <!-- <template slot="pre_base_button">
        <button class="pre_btn_ok" @click="fun_show_step">审核流程</button>
      </template> -->
      <!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->
    </pre-base>

  </div>
</template>

<script>
  import api from '@/utils/type.js';
  import {
    Method_EasySelect
  } from '@/utils/loadhttpdata.js';
  export default {
    components: {
      "pre-base": () => import("../auto/old_view_v1.vue"),
      // 'pre-select': () => import("../personmode/pre_select_one.vue"),
    },
    data() {
      return {
        init_data: '',
        row_id: '',
        item: '',

        // 组件
        show_tan: '0',
        show_item: '',
        // 下拉菜单
        // list_fee: [],
        // sel_fee: {},

      };
    },
    mounted: function() {
      var that = this;
      this.$nextTick(function() {
        that.fun_init();
      });
    },
    methods: {
      fun_init: async function() {


        let list_flag = [];
        list_flag = await this.loadClass('flag');

        // console.log(list_things);

        this.init_data = '';
        this.init_data = JSON.stringify({
          "title": '律师事务所',
          "control": "lawstore",
          "isTwo": "1",
          "action_flag": "",
          "sel_action_flag": "",  //更多查询
          "isFileMain": "1",
          "sel_action": 'exp_fw_law_store',
          "upd_action": 'exp15_fw_law_store',
          "d_sel_action": '',
          "d_upd_action": '',
          "file_action": '',
          "p1": 'fawu',
          "p2": 'law',
          "p3": '',
          "parm_sel": [
            {
              "name": "事务所名称",
              "val": "",
              "key": "c_name",
              "type": "text",
              "class": "long1",
              "sel": "1"
            },
            {
              "name": "负责人",
              "val": "",
              "key": "c_leader",
              "type": "text",
              "class": "long1",
              "sel": "2"
            },
            {
              "name": "状态",
              "val": "",
              "key": "flag",
              "type": "select",
              "class": "long1",
              "sel_action": "_base_flag",
              "sel_val": {},
              "sel_name": "",
              "sel": "3"
            }
          ],
          "parm": [
            {
              "name": "事务所名称",
              "val": "",
              "key": "c_name",
              "type": "text",
              "class": "long1",              
              "p": "1",
			  "w":"1",
			  "r":"0",
			  "x":"1"
            },
            {
              "name": "负责人",
              "val": "",
              "key": "c_leader",
              "type": "text",
              "class": "long1",
              "p": "1",
              "w":"1",
              "r":"0",
              "x":"1"
            },
            {
              "name": "电话",
              "val": "",
              "key": "c_phone",
              "type": "number",
              "class": "long1",
              "p": "1",
              "w":"1",
              "r":"0",
              "x":"1"
            },
            {
              "name": "开始日期",
              "val": "",
              "key": "s_date",
              "type": "date",
              "class": "long1",
              "p": "1",
              "w":"0",
              "r":"0",
              "x":"2"
            },
            {
              "name": "截止日期",
              "val": "",
              "key": "e_date",
              "type": "date",
              "class": "long1",
              "p": "1",
              "w":"0",
              "r":"0",
              "x":"2"
            },
            {
              "name": "代理费",
              "val": "",
              "key": "pay_fee",
              "type": "number",
              "class": "long1",
              "p": "1",
              "w":"0",
              "r":"0",
              "x":"2"
            },
            {
              "name": "付款方式",
              "val": "",
              "key": "pay_note",
              "type": "text",
              "class": "long1",
              "p": "1",
              "w":"0",
              "r":"0",
              "x":"2"
            },
            {
              "name": "备注",
              "val": "",
              "key": "note",
              "type": "text",
              "class": "long3",
               "p": "1",
               "w":"0",
               "r":"0",
               "x":"3"
            }
          ],
          "parm_th": [
            {
              "name": "序号"
            },
            {
              "name": "律师事务所",
              "class":"long2"
            },
            {
              "name": "负责人"
            },
            {
              "name": "电话"
            },
            {
              "name": "开始日期"
            },
            {
              "name": "截止日期"
            },
            {
              "name": "状态"
            },


            {
              "name": "代理费"
            },
            {
              "name": "付款方式"
            },
            {
              "name": "备注",
              "class":"long2"
            },

            {
              "name": "录入人",
              "class":"short0"
            },
            {
              "name": "更新时间"
            }
          ]
        });

        // this.loadClass('sfee');

      },
      refresh_data: function(type) {
        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase'].refresh_data(type);
        });
      },
      refresh_children: function(type, id, val) {
        var that = this;
        if (type == 'slot_c_out_fee') {
          this.$nextTick(function() {
            that.$refs['mybase'].refesh_parm(type, id, val, 'children');
          });
        } else {
          this.$message({
            message: '类别=!' + type + ' 没有配置相关操作!',
            type: 'error'
          });
        }
      },
      refresh_father: function(type, val, parm) {
        // console.log('type=' + type + ' val=' + val);
        switch (type) {
          case 'father':
            // 弹出修改明细，修改主窗口信息
            this.refresh_data();
            break;
          case 'blank':
            // 清空下拉菜单选项 没有起作用
            console.log('清空下拉菜单');
            this.sel_depart = {};
            break;
            // case 'slot_c_out_fee':
            //   this.selectFunc1(val);
            //   if (val == 'clear') {
            //     this.$refs['out_fee'].clearselect();
            //   }
            //   break;
          default:
            // console.log('子组件刷新父组件传值=' + val);
            this.row_id = val;
            this.item = parm;
            break;
        }
      },
      loadClass: function(action, p1, p2, p3) {

        // this.$post(
        //   api.http_method, Method_EasySelect('data_exp_feeclass', '', '', type)
        // ).then(res => {
        //   res = JSON.parse(res);
        //   if (res.data.status == 1) {
        //     this.list_fee = [];
        //     this.list_fee = res.data.data;
        //   }
        // });

        let that = this;
        return new Promise((resolve, reject) => {
          // console.log(menuvalue);
          that.$post(
            api.http_method, Method_EasySelect('data_' + action, p1, p2, p3)
          ).then(res => {
            res = JSON.parse(res);
            // console.log(res.data);
            resolve(res.data)
          });

        });
      },


    }
  };
</script>
<style>
</style>
